export default __webpack_public_path__ + "static/media/indiakabttleM.90a9714e.png";